import {
  ApiGetRequest,
  ApiPostRequest,
  ApiDeleteRequest,
  ApiPutRequest,
} from '../../../api';
import { showNotif } from '../../notification';

export const state = {
  data: {
    title: 'Master Kelompok Harta',
    title_form: 'Form Kelompok Harta',
    breadcrumb: [
      {
        text: 'Dashboard',
        href: '/fin',
      },
      {
        text: 'Kelompok Harta',
        href: '/adm/fin/master/kelompok-harta',
        active: true,
      },
    ],
    items: [],
    total: 0,
    page: 1,
    limit: 10,
    pageOptions: [10, 25, 50, 100],
    search: '',
    sortBy: '',
    sortDesc: false,
    fields: [
      {
        key: 'code_kelompok',
        label: 'Kode',
        sortable: true,
      },
      {
        key: 'kelompok',
        label: 'Kelompok',
        sortable: true,
      },
      {
        key: 'metode',
        label: 'Metoda',
        sortable: true,
      },
      {
        key: 'umur_ekonomis',
        label: 'Umur Ekonomis',
        sortable: true,
      },
      {
        key: 'aksi',
        label: 'Aksi',
      },
    ],
    detail: false,
    form: {
      id_pic: '',
    },
    form_kelompok: {
      kelompok: '',
      metode: '',
      umur_ekonomis: '',
      acc_asset: '',
      acc_accumulation: '',
      acc_depresiasi: '',
    },
    kelompok_harta: [],
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
  form_kelompok(state) {
    return state.data.form_kelompok;
  },
};

export const mutations = {
  changeKelompokHarta(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async searchKelompokHarta(context, params = null) {
    let result = await ApiGetRequest(`fin/kelompok-harta`, params);
    return !result.error ? result.data.object : [];
  },

  async getListKelompokHarta({ commit, state }) {
    commit('changeKelompokHarta', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
    };

    let result = await ApiGetRequest(`fin/kelompok-harta`, params);
    commit('changeKelompokHarta', {
      items: !result.error ? result.data.object : [],
      total: !result.error ? result.data.total : 0,
      loading: false,
    });

    return !result.error ? true : false;
  },

  async getDetailKelompokHarta({ commit }, payload = null) {
    commit('changeKelompokHarta', {
      loading: true,
    });

    let result = await ApiGetRequest(`fin/kelompok-harta/${payload.id}`);
    commit('changeKelompokHarta', {
      loading: false,
    });

    if (!result.error) {
      commit('changeKelompokHarta', {
        form_kelompok: {
          ...result.data.object,
        },
      });
    }

    return result.error ? false : true;
  },

  async getAllKelompokHarta({ commit }) {
    commit('changeKelompokHarta', {
      loading: true,
    });

    let result = await ApiGetRequest(`fin/kelompok-harta`);
    commit('changeKelompokHarta', {
      kelompok_harta: !result.error ? result.data.object : [],
      loading: false,
    });

    return !result.error ? true : false;
  },

  async createKelompokHarta({ commit, state, dispatch }) {
    commit('changeKelompokHarta', {
      loading: true,
    });

    let result = await ApiPostRequest(
      `fin/kelompok-harta`,
      state.data.form_kelompok
    );
    commit('changeKelompokHarta', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async updateKelompokHarta({ commit, state, dispatch }, payload = null) {
    commit('changeKelompokHarta', {
      loading: true,
    });

    let result = await ApiPutRequest(
      `fin/kelompok-harta/${payload.id}`,
      state.data.form_kelompok
    );

    commit('changeKelompokHarta', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async deleteKelompokHarta({ commit, dispatch }, payload = null) {
    commit('changeKelompokHarta', {
      loading: true,
    });

    let result = await ApiDeleteRequest(`fin/kelompok-harta/${payload.id}`);
    commit('changeKelompokHarta', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });
    }

    return result.error ? false : true;
  },
};
